/**
 * Defines the privilege packages (roles) for the application.
 * Each package has a name and a set of privileges.
 * The privileges are defined as an object where keys are module names
 * and values are an array of permitted operations.
 */
export const privilegePackages = [
    {
        name: 'Receptionist',
        value: 'receptionist',
        description: 'Access for front-desk staff to manage patients and appointments.',
        privileges: {
            patients: ['view', 'create'],
            doctors: ['view', 'create'],
            appointments: ['view', 'create'],
            patientHistory: ['view'],
            scans: ['view'],
            radiologists: ['view'],
            users: ['view'],
            branches: ['view'],
            representatives: ['view'],
            radiologyTechnicians: ['view'],
            expenses: ['view', 'create'],
            doctorSpecialization: ['view'],
            scanCategories: ['view'],
            stock: ['view'],
            stockCategories: ['view'],
            centralStock: ['view'],

            // Ensure other modules are not included or have empty operations
        }
    },
    {
        name: 'Radiologist',
        value: 'radiologist',
        description: 'Access for radiologists to view patient data and scans.',
        privileges: {
            appointments: ['view'], // Radiologists might update scan status
            scans: ['view'], // They create/update scan reports
            patients: ['view'],
            patientHistory: ['view'],
            doctors: ['view'],
        }
    },
    {
        name: 'Representative',
        value: 'representative',
        description: 'Access for representatives to view patient data and scans.',
        privileges: {
            appointments: ['view'], // Radiologists might update scan status
            scans: ['view'], // They create/update scan reports
            patients: ['view'],
            dashboard: ['view'],
            representatives: ['view'],
            users: ['view'],
            branches: ['view'],
            doctors: ['view', 'create'],
            doctorSpecialization: ['view'],
            scanCategories: ['view'],
        }
    },
    // You can add more packages here in the future
    // e.g., { name: 'Accountant', ... }
];